import { render, staticRenderFns } from "./PricingThree.vue?vue&type=template&id=3a2a0bbf&"
import script from "./PricingThree.vue?vue&type=script&lang=js&"
export * from "./PricingThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports